import { render } from "./CookieAccept.vue?vue&type=template&id=6c2023e2"
import script from "./CookieAccept.vue?vue&type=script&lang=js"
export * from "./CookieAccept.vue?vue&type=script&lang=js"

import exportComponent from "/Users/nikita/Documents/works/novosel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__